import { Box, Text, TextProps } from '@jfs/ui-new'

const WrapperText = (props: TextProps) => {
  return (
    <Box maxWidth={200} padding={4}>
      <Text {...props} />
    </Box>
  )
}

export { WrapperText }
